import { Environment } from "./Environment";

export const Endpoints = {
  get API_BASE_URL() {
    return Environment.url;
  },
  get GET_Token() {
    return this.API_BASE_URL + "Notification/GetTokenId";
  },

  get LogIn() {
    return this.API_BASE_URL + "Login/LoadLogin";
  },

  get GetTreatmentCostEstimator()
  {
    return this.API_BASE_URL + "TreatmentStatus/GetTreatmentCostEstimatorDetails"
  },
  get GetTreatmentPackageList()
  {
    return this.API_BASE_URL + "Treatmentstatus/GetTreatmentPackageList"
  },
// Home
get GetDashboardDetails()
{
  return this.API_BASE_URL + "Profile/GetDashboardDetails"
},

//UpdateJourneyStatus
get UpdateJourneyStatus()
{
  return this.API_BASE_URL + "Profile/UpdateJourneyStatus"
},

// Support Module
get GetDashboardServiceDetails()
{
  return this.API_BASE_URL + "Profile/GetDashboardServiceDetails"
},
get Getjson()
{
  return this.API_BASE_URL + "common/getjson"
},
get VitalExchange()
{
  return this.API_BASE_URL + "FamilyServices/VitalExchange"
},
// Trackers
// Pregnancy Tracker
get LoadMenstrualCycleCalendarData()
{
  return this.API_BASE_URL + "MenstrualCycle/LoadMenstrualCycleCalendarData"
},
get LoadReminderEventData()
{
  return this.API_BASE_URL + "Reminder/LoadReminderEventData"
},
get LoadReminderData()
{
  return this.API_BASE_URL + "Reminder/LoadReminderData"
},
get SaveReminder()
{
  return this.API_BASE_URL + "Reminder/SaveReminder"
},
get DeleteReminder()
{
  return this.API_BASE_URL + "Reminder/DeleteReminder"
},
get SaveEvent()
{
  return this.API_BASE_URL + "Event/SaveEvent"
},
get SendMyGraphs()
{
  return this.API_BASE_URL + "Profile/SendMyGraphs"
},
get SavePatientVitals()
{
  return this.API_BASE_URL + "Profile/SavePatientVitals"
},
get LoadPatientVitals()
{
  return this.API_BASE_URL + "Profile/LoadPatientVitals"
},
get LoadMarketPlace()
{
  return this.API_BASE_URL + "Profile/LoadMarketPlace"
},
get LoadMarketPlaceDetails()
{
  return this.API_BASE_URL + "Profile/LoadMarketPlaceDetails"
},

// Fertility Tracker
get SaveMenstrualCycle()
{
  return this.API_BASE_URL + "MenstrualCycle/SaveMenstrualCycle"
},
get UpdateMenstrualDataConsent()
{
  return this.API_BASE_URL + "MenstrualCycle/UpdateMenstrualDataConsent"
},
get LoadAccumulatorBySpeciality()
{
  return this.API_BASE_URL + "Premier/LoadAccumulatorBySpeciality"
},
get SendAccumulatorDetails()
{
  return this.API_BASE_URL + "Premier/SendBusAccumulatorDetails"
},
get LoadMenstrualCycleData()
{
  return this.API_BASE_URL + "MenstrualCycle/LoadMenstrualCycleData"
},

get Notificationload(){
  return this.API_BASE_URL + "Notification/LoadNotificationsList"
},
get LoadReviewRX(){
  return this.API_BASE_URL + "ReviewRX/LoadReviewRX"
},
get SaveRxDrugRows(){
  return this.API_BASE_URL + "ReviewRX/SaveRxDrugRows"
},
get LoadReviewRX(){
  return this.API_BASE_URL + "ReviewRX/LoadReviewRX"
},
get FindCheapestPharmacy(){
  return this.API_BASE_URL + "ReviewRx/FindCheapestPharmacy"
},
get LoadRxOnlyAuthorizations(){
  return this.API_BASE_URL + "ReviewRX/LoadRxOnlyAuthorizations"
},
get GetRXDetailsList(){
  return this.API_BASE_URL + "TreatmentStatus/GetRXDetailsList"
},
get SaveFourthTrimisterCheckin(){
  return this.API_BASE_URL + "Maternity/SaveFourthTrimisterCheckin"
},
get LoadFourthTrimesterDetails() {
  return this.API_BASE_URL + "Maternity/LoadFourthTrimesterDetails"
},
get VerifyWINOnesieGiftBoxAddress(){
  return this.API_BASE_URL + "CreateAccount/VerifyWINOnesieGiftBoxAddress"
},
get LoadCountry(){
  return this.API_BASE_URL +"Address/LoadCountry"
},
get LoadState(){
  return this.API_BASE_URL +"Address/LoadState"
},
get LoadCity(){
  return this.API_BASE_URL +"Address/LoadCity"
},
get SaveMultiplePregnency(){
  return this.API_BASE_URL + "Maternity/SaveMultiplePregnency"
},
get SaveMiraDetails(){
  return this.API_BASE_URL + "Mira/SaveMiraDetails"
},
get LoadMiraDetails(){
  return this.API_BASE_URL + "Mira/LoadMiraDetails"
},
get LoadMiraDetails(){
  return this.API_BASE_URL + "Mira/LoadMiraDetails"
},
// Benefits 
  get ReimbursementProviderDetails() {
    return this.API_BASE_URL + "UploadDocument/ReimbursementProviderDetails";
  },
get UnderstandingBenefits(){
	return this.API_BASE_URL + "Login/UnderstandingBenefits";
  },
  
  get LoadAuth(){
	return this.API_BASE_URL + "Letter/LoadAuth";
  },
  
  get LoadLetter(){
	return this.API_BASE_URL + "Letter/LoadLetter";
  },
  
  get LoadandConvertDocument() {
	return this.API_BASE_URL + "Letter/LoadandConvertDocument";
  },

  get GetDocumentType(){
    return this.API_BASE_URL + "UploadDocument/GetDocumentType";
  },
    
    get LoadTreatmentStatus(){
    return this.API_BASE_URL + "TreatmentStatus/LoadTreatmentStatus";
    },

    get SupportingDocServices(){
      return this.API_BASE_URL + "UploadDocument/SupportingDocServices";
    },    
    
    get ChangePassword(){
    return this.API_BASE_URL + "ForgotPassword/ChangePassword";
    },

    get loadprovidersearchfeed(){
      return this.API_BASE_URL + "Profile/loadprovidersearchfeed";
      },
      
      get LoadNonPhysicianProviders(){
      return this.API_BASE_URL + "Profile/LoadNonPhysicianProviders";
      },

      get LoadPersonalizedListOfProviders(){
        return this.API_BASE_URL + "ProviderSearch/LoadPersonalizedlistofproviders";
      },

      get LoadProviderDirectory(){
        return this.API_BASE_URL + "ProviderSearch/LoadProviderDirectory";
      },
      
      get SaveFavouriteNonPhysicianProviders(){
      return this.API_BASE_URL + "Profile/SaveFavouriteNonPhysicianProviders";
      },
      
      get LoadZipcode(){
      return this.API_BASE_URL + "ProviderSearch/LoadZipcode";
      },
      
      get SaveZipcode(){
      return this.API_BASE_URL + "ProviderSearch/SaveZipcode";
      },

      get SaveFeedback(){
      return this.API_BASE_URL + "Profile/SaveFeedback";
      },
      
      get SaveProviderDetails(){
      return this.API_BASE_URL + "ProviderSearch/SaveProviderDetails";
      },      get LoadDiagnosisDropDownValues(){
        return this.API_BASE_URL + "ProviderSearch/LoadDiagnosisDropDownValues";
      },
      get LoadGroupNames(){
        return this.API_BASE_URL + "ProviderSearch/LoadGroupNames";
      },
      get LoadPHIForm(){
        return this.API_BASE_URL + "PHIForm/LoadPHIForm";
        },
        get SavePHIForm(){
          return this.API_BASE_URL + "PHIForm/SavePHIForm";
          },
          get AppWhyHere(){
            return this.API_BASE_URL + "CreateAccount/AppWhyHere";
            },   
            get CreateAccount(){
              return this.API_BASE_URL + "CreateAccount/CreateAccount";
              },  
              
              get validateemail(){
                return this.API_BASE_URL + "CreateAccount/validateemail";
                }, 

                get UpdateMemberConsent(){
                  return this.API_BASE_URL + "ReviewRX/UpdateMemberConsent";
                },
                get LoadMiraDataSyncConsent(){
                  return this.API_BASE_URL + "Mira/LoadMiraDataSyncConsent";
                },
                get SaveMiraDataSyncConsent(){
                  return this.API_BASE_URL + "Mira/SaveMiraDataSyncConsent";
                },
                get GetMiraLink() {
                  return this.API_BASE_URL + "Profile/GetMiraLink";
                },
                get SaveQRMemberDetails(){
                  return this.API_BASE_URL + "Login/SaveQRMemberDetails";
                },

get fetchConsultationTypes()
{
  return this.API_BASE_URL + "Profile/GetConsultationTypes"
},

get GetTimeZones()
{
  return this.API_BASE_URL + "nurseconsults/GetTimeZones"
},

get fetchCalendarDates()
{
  return this.API_BASE_URL + "NurseConsults/LoadCalendarInfo_New"
},

get fetchAvailableSlots()
{
  return this.API_BASE_URL + "NurseConsults/LoadAvailableSlots"
},

get fetchAppointments()
{
  return this.API_BASE_URL + "NurseConsults/ValidationList"
},

get confirmCancellation()
{
  return this.API_BASE_URL + "NurseConsults/SaveNurseSchedule"
},

get handleBookAppointment()
{
  return this.API_BASE_URL + "NurseConsults/SaveNurseSchedule"
},

get LoadNCAProfileDetails()
{
  return this.API_BASE_URL + "NurseConsults/LoadNCAProfileDetails"
 },

get handleSend()
{
  return this.API_BASE_URL + "chatbot/cannedresponses"
},
get ForgotPassword()
{
  return this.API_BASE_URL + "ForgotPassword/ForgotPassword"
},
get SaveWinChatToken()
{
  return this.API_BASE_URL + "Profile/SaveWinChatToken"
},
get GetTwilioAccessToken()
{
  return this.API_BASE_URL + "Twilio/GetTwilioAccessToken"
},
get SaveNotificationStatus(){
  return this.API_BASE_URL + "Profile/SaveNotificationStatus"
},
get SaveTextNotificationStatus(){
 return this.API_BASE_URL + "Profile/SaveTextNotificationStatus"
 },
 get UploadDocument(){
  return this.API_BASE_URL + "UploadDocument/Upload"
 },
 get LoadWinCardDetails(){
  return this.API_BASE_URL + "TreatmentStatus/LoadWinCardDetails"
   },
  get SendToWin(){
      return this.API_BASE_URL + "UploadDocument/SendToWin"
       },
  get LoadServiceType(){
        return this.API_BASE_URL + "UploadDocument/LoadServiceType"
      },
      get LoadCurrencies(){
        return this.API_BASE_URL + "UploadDocument/LoadCurrencies"
      },
      get FetchReimbursement(){
        return this.API_BASE_URL + "UploadDocument/FetchReimbursement"
      },

      get providerappointment(){
        return this.API_BASE_URL + "ProviderSearch/ScheduleProviderAppointment"
      },
      get GetSigningDocument(){
        return this.API_BASE_URL + "Docusign/GetSigningDocument"
      },
      get SigningCompleted(){
        return this.API_BASE_URL + "Docusign/SigningCompleted"
      },
      get CallRecoderLog(){
        return this.API_BASE_URL + "Event/CallRecoderLog"
      },
     get BHAssessment(){
      return this.API_BASE_URL + "Notification/LoadBHAssessmentDropDownValues"
     },
     get BHAssessmentSave(){
      return this.API_BASE_URL + "Notification/SaveBHAssessment"
     },
     get GetHighRiskMaternityAssessment(){
      return this.API_BASE_URL + "Notification/GetHighRiskMaternityAssessmentDetails"
     },
     get SaveHighRiskMaternityAssessment(){
      return this.API_BASE_URL + "Notification/SaveHighRiskMaternityAssessment"
     },
     get SaveConsultationRating(){
      return this.API_BASE_URL + "Notification/SaveRateYourConsult"
     },
     get SaveWincentiveStory(){
      return this.API_BASE_URL + "WINcentive/SaveHealthAssessmentDetails"
     },
     get GetProcedurePackageList(){
      return this.API_BASE_URL + "TreatmentStatus/GetProcedurePackageList"
     },
     get GetGroupDetails(){
      return this.API_BASE_URL + "ProviderSearch/GetGroupDetails"
     },
     get GetProviderDetails(){
      return this.API_BASE_URL + "ProviderSearch/GetProviderDetails"
     },
     get MemberReqAuth(){
      return this.API_BASE_URL + "TreatmentStatus/MemberReqAuth"
     },
     get MemberReqRX(){
      return this.API_BASE_URL + "TreatmentStatus/MemberReqRX"
     },
     get SaveRewardRedemptionDetails(){
      return this.API_BASE_URL + "Wincentive/SaveRewardRedemptionDetails"
     },
     get GetWINAchievementsDetails(){
      return this.API_BASE_URL + "WINcentive/GetWINAchievementsDetails"
     },
     get GetWINRewardsTrackerDetails(){
      return this.API_BASE_URL + "WINcentive/GetWINRewardsTrackerDetails"
     },
     get GetWINRewardsHistoryDetails(){
      return this.API_BASE_URL + "WINcentive/GetWINRewardsHistoryDetails"
     },
     get SaveHbA1cDetails(){
      return this.API_BASE_URL + "WINcentive/SaveHbA1cDetails"
     },
     get LoadMaternityWeeklyTracker(){
      return this.API_BASE_URL + "Maternity/LoadMaternityWeeklyTracker"
     },
     get LoadMaternityWeeklyRecipe(){
      return this.API_BASE_URL + "Maternity/LoadMaternityWeeklyRecipe"
     },
     get LoadPregnancyTrackerDetails(){
      return this.API_BASE_URL + "Maternity/LoadPregnancyTrackerDetails"
     },
     get VerifyWINcentiveWelcomeBoxAddress(){
      return this.API_BASE_URL + "Createaccount/VerifyWINcentiveWelcomeBoxAddress"
     },
     get ValidateSSO(){
      return this.API_BASE_URL + "Notification/ValidateSSO"
     },
     get SaveInsuranceData(){
      return this.API_BASE_URL + "Profile/SaveInsuranceData"
     },
     get StateandCountry(){
      return this.API_BASE_URL + "Address/LoadState"
     },
     get ExportPregnencyTrendReport(){
      return this.API_BASE_URL + "Profile/ExportPregnencyTrendReport"
     },
     get UpdatePregnancyDataConsent(){
      return this.API_BASE_URL + "Profile/UpdatePregnancyDataConsent"
     },
     get LoadWINCardDetails(){
      return this.API_BASE_URL + "TreatmentStatus/LoadWINCardDetails"
     },
      get SavePreconception(){
      return this.API_BASE_URL + "CreateAccount/SavePreconception"
     },
       get SaveConsentQuestions(){
      return this.API_BASE_URL + "CreateAccount/SaveConsentQuestions"
     },
       get TextForgotPassword(){
      return this.API_BASE_URL + "ForgotPassword/TextForgotPassword"
     },

     get UCMemberReqAuth(){
      return this.API_BASE_URL + "TreatmentStatus/UCMemberReqAuth"
     },       get SaveMinorAccessConsent(){
      return this.API_BASE_URL + "CreateAccount/SaveMinorAccessConsent"
     },
     get RegisterUserforWebinar(){
      return this.API_BASE_URL + "ZoomWebinar/RegisterUserforWebinar"
     },
     get UKDTCServiceAmounts(){
      return this.API_BASE_URL + "createaccount/LoadUKDTCServiceAmounts"
     },
     get GetUKDTCPaymentLink(){
      return this.API_BASE_URL + "Createaccount/getukdtcpaymentlink"
     },
     get UpdateUKDTCDetails(){
      return this.API_BASE_URL + "Createaccount/UpdateUKDTCDetails"
     },
     get OidcIntegration(){
      return this.API_BASE_URL + "Oidc/OidcIntegration"
     },
     get SaveBlueBerryDetails(){
      return this.API_BASE_URL + "Profile/SaveBlueBerryDetails"
     },
     get ValidateReturntoWorkPay(){
      return this.API_BASE_URL + "Profile/ValidateReturntoWorkPay"
     },
     get SaveReturntoWork(){
      return this.API_BASE_URL + "Profile/SaveReturntoWork"
     }
     
};
